<template>
  <div>
    <HeadBar /><!--顶部bar-->
    <HeadNav /><!-- 顶部导航-->
    <div class="con">
      <div class="con-inner flex flex-row">
        <div class="types">
          <div
            v-for="(item, index) in types"
            :key="index"
            class="types-item pointer"
            :class="{
              active: activeIndex === index,
            }"
            @click="typeClick(index)"
          >
            {{ item.dictLabel }}
          </div>
        </div>
        <div class="flex-1 article">
          <EditorView
            :data="article.adviceTrainContent"
            v-if="article.adviceTrainContent"
          />
          <el-empty description="未查询到数据"></el-empty>
        </div>
      </div>
    </div>
    <FootBar />
  </div>
</template>
<script>
import { CONSULT_TYPE } from "@/constant/dict";
import { consultDetail } from "@/api/consultTrain";
export default {
  data() {
    return {
      types: [],
      activeIndex: 0,
      article: {},
    };
  },
  async created() {
    await this.getDict();
    this.getArticle();
  },
  methods: {
    async getDict() {
      const data = await this.$store.dispatch("getDictData", CONSULT_TYPE);
      this.types = data;
    },
    async getArticle() {
      const data = await this.$axios.get(
        consultDetail + this.types[this.activeIndex].dictValue
      );
      this.article = data || {};
    },
    typeClick(index) {
      this.activeIndex = index;
      this.getArticle();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.article {
  background: white;
  padding: 10px;
}
.types {
  background: white;
  margin-right: 15px;
  width: 150px;
  &-item {
    text-align: center;
    line-height: 40px;
    margin-bottom: 5px;
    &.active,
    &:hover {
      color: white;
      background: $theme-color;
    }
  }
}
.con {
  background: $home-bg;
  &-inner {
    padding: 20px 0;
    min-height: 500px;
    width: $max-width;
    margin: 0 auto;
  }
}
</style>
